import { AxiosInstance } from 'axios';
import { toast } from 'sonner';

import { useMutation } from '@/utils/api';

/**
 * Hook to handle agent installer downloads
 *
 * Provides mutation for downloading MSI, DEB, or RPM installers
 * with proper error handling and user feedback
 */
export const useDownloadInstaller = (axios: AxiosInstance) => {
  return useMutation({
    mutationFn: async (type: 'msi' | 'deb' | 'rpm') => {
      const response = await axios.get(`/aegis/installer/${type}`, {
        responseType: 'text',
      });
      if (response.status !== 200) {
        const upperType = type.toUpperCase();
        throw new Error(`Failed to download ${upperType} installer`);
      }
      const url = atob(response.data);
      const a = document.createElement('a');
      a.href = url;
      const upperType = type.toUpperCase();
      a.download = `PraetorianAegis${upperType}.${type}`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    },
    onError: (error: Error, _variables) => {
      toast.error(error?.message || 'Failed to download installer');
    },
    defaultErrorMessage: 'Failed to download Aegis installer',
    errorByStatusCode: {
      400: 'Client not enrolled. Please ensure your system is properly configured before downloading the installer.',
      404: 'Installer not found. The requested installer type may not be available.',
      500: 'Server error occurred while generating installer. Please try again later.',
    },
  });
};
